import { AppContainer, AppContent } from 'twyne-new.ui';

import Filters from "./Filters";
import DefaultTable from "./Table";
import Wrapper from "./Wrapper";
import DefaultHeading from "./header/Heading";

export default function DefaultGrid({ filters = <Filters />, heading = <DefaultHeading />, table = <DefaultTable />, className }) {
  return <>
    <Wrapper className={className}>
      <AppContainer direction='vertical'>
        {heading}
        <AppContainer>
          {filters}
          <AppContainer direction='vertical'>
            <AppContent>
              {table}
            </AppContent>
          </AppContainer>
        </AppContainer>
      </AppContainer>
    </Wrapper>
  </>
}
